import { useEffect } from 'react';

const ExternalLinkPage = () => {
  const externalLink = 'https://bizcotap.com';

  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      window.location.href = externalLink;
    }, 2000);

    return () => {
      clearTimeout(redirectTimer);
    };
  }, []);

  return (
    <div className='flex h-screen justify-center items-center'>
      <p className='text-primary font-bold text-xl px-10 text-center'>
        You will be redirected to bizcotap official website in 2 second...
      </p>
    </div>
  );
};

export default ExternalLinkPage;
